import type { IconProps } from '.';

/**
 * X Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const XIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
  >
    <path
      d="M13.6513 0.6875H16.1333L10.7122 6.88203L17.0896 15.3125H12.0974L8.18447 10.2008L3.7126 15.3125H1.22705L7.02432 8.68555L0.910645 0.6875H6.02939L9.5626 5.35977L13.6513 0.6875ZM12.7794 13.8289H14.154L5.28057 2.09375H3.804L12.7794 13.8289Z"
      fill="white"
    />
  </svg>
);

export default XIcon;
